import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const NikolaCreditsLink = ({ available, compact = false }: { available: number | null; compact?: boolean }) => (
  <Box
    component={RouterLink}
    to="/subscription?credits=1"
    aria-label={`${available ?? "Unknown"} Nikola credits available. Open Subscription.`}
    sx={{
      display: "grid",
      gridTemplateColumns: compact ? "auto 1fr auto" : "1fr auto",
      alignItems: "center",
      gap: 1,
      minHeight: 52,
      px: 2,
      color: "primary.main",
      textDecoration: "none",
      "&:hover, &:focus-visible": { bgcolor: "rgba(240,236,226,0.06)" },
    }}
  >
    {compact && (
      <Typography aria-hidden sx={{ fontSize: 18, lineHeight: 1 }}>
        ◫
      </Typography>
    )}
    <Box>
      <Typography sx={{ fontSize: 10, fontWeight: 900, letterSpacing: ".1em" }}>NIKOLA CREDITS</Typography>
      {!compact && (
        <Typography sx={{ mt: 0.25, color: "text.secondary", fontSize: 10 }}>AVAILABLE NOW · MANAGE</Typography>
      )}
    </Box>
    <Typography sx={{ color: "secondary.main", fontSize: compact ? 18 : 24, lineHeight: 1, fontWeight: 900 }}>
      {available ?? "—"}
    </Typography>
  </Box>
);
